import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, notification } from "antd";

import { NavigationPath } from "../../helpers/constants";
import ActionButtons from "../ActionButtons/ActionButtons";
import moment from "moment";

const Brendovi = ({ state: { brands }, actions }) => {
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);

  useEffect(() => {
    setLoading(true);
    actions.getBrands();
    setLoading(false);
  }, []);

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
      style: {
        width: 400,
      },
    });
  };

  const columns = [
    {
      title: "Naziv branda",
      dataIndex: "name",

      render: (text) => <a className="text-light-blue">{text}</a>,
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "createdAt",
      width: 180,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedBrand(selectedRows);
    },
  };
  const onChange = (pagination, sorter) => {};

  const navigateToRegisterBrand = () => {
    navigate(NavigationPath.ADD_BRAND_ROUTE);
  };

  const navigateToEdit = () => {
    if (selectedBrand?.length === 1) {
      navigate(`/brands/${selectedBrand[0].key}`);
    } else {
      openNotificationWithIcon("warning", "Select one brand to edit");
    }
  };

  const handleDeleteBrand = () => {
    if (selectedBrand) {
      const brandIds = selectedBrand.map((brand) => brand.key);
      actions.deleteBrand(brandIds);
      setSelectedBrand(null);
    }
  };

  return (
    <div>
      {contextHolder}
      <div className="px-8 py-4">
        <ActionButtons
          navigateToAdd={navigateToRegisterBrand}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteBrand}
          selectedUser={selectedBrand}
        />
      </div>

      <Table
        columns={columns}
        loading={loading}
        dataSource={brands?.map((brand) => ({
          key: brand.id,
          name: brand.name,
          createdAt: moment(brand.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        }))}
        rowSelection={{
          ...rowSelection,
        }}
        onChange={onChange}
      />
    </div>
  );
};

export default Brendovi;
